"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButtonTheme = void 0;
var _colors = require("../../../colors");
var IconButtonTheme = exports.IconButtonTheme = {
  iconColor: _colors.FullPalette.EVERGREEN_700,
  hover: {
    backgroundColor: _colors.FullPalette.IRIS_E50
  },
  active: {
    backgroundColor: _colors.FullPalette.GREY_E500
  },
  disabled: {
    backgroundColor: 'none',
    iconColor: _colors.FullPalette.GREY_700
  }
};